import { useState } from "react";
import "../styles/portal/Signin.css";

function Verificacao() {
    const [verificationCode, setVerificationCode] = useState('');

    return (
        <div className="signin-container">
            <h2>Confirmação de conta</h2>
            <h2>Verifique seu e-mail e insira o código de 6 dígitos para fazermos a ativação da conta</h2>
            <form className="signin-form" onSubmit={() => console.log("O")}>
                <label>Código de verificação:</label>
                <input
                    required
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                />
                <input type="submit" value="Verificar"></input>
            </form>        
        </div>
    )
}

export default Verificacao
